// CPU 評価関数定数（データ駆動）
//
// 評価の単位は「5連窓」(threat-scan.ts 参照)。連続・ギャップ問わず、
// 5マス連続の窓に自石が何個入っているかで脅威を分類する。
// これにより 飛び4 (BBB_B など) も 4石窓として 1手詰めとして検出される。
//
// 設計方針:
//   - 自分の攻撃より相手阻止を強化（防御係数 > 攻撃係数）
//   - 窓ベースなので open-4 は 2 窓 = 攻撃 2000, 防御 8000 と自動的に2倍になる
//   - 片開き4連・飛び4 は 1 窓 = 攻撃 1000, 防御 4000
export const AI_EVAL = {
  // 勝ち（5連達成）/ 相手の5連を未然防御
  WIN: 100_000,
  BLOCK_WIN: 90_000,

  // 4石+1空き の 5連窓 1つあたりの評価
  //   open-4     (_BBBB_): 2窓 → attack 2000, block 8000
  //   closed-4   (BBBB_):  1窓 → attack 1000, block 4000
  //   飛び4      (BBB_B):  1窓 → attack 1000, block 4000
  FOUR: 1_000,
  BLOCK_FOUR: 4_000,

  // 3石+2空き の 5連窓 1つあたりの評価
  //   open-3   (_BBB_):  3窓（理論上）→ attack 210, block 1200
  //   closed-3 (XBBB_):  1〜2窓     → attack 70–140, block 400–800
  //   飛び3    (BB_B_):  複数窓で検出
  THREE: 70,
  BLOCK_THREE: 400,

  // 2石+3空き の 5連窓 1つあたりの評価（足場）
  TWO: 4,
  BLOCK_TWO: 8,

  // 中心引力（盤面中央寄りの微加点）
  CENTER_BIAS: 3,

  // スコア差の重み（1手で増える「ナワバリ得点」差に乗じる）
  SCORE_GAIN_WEIGHT: 10,
} as const
